/**
 * @desc appId2ServiceName
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<string>;
export function request(
  params: API.appCenter.appFacadeImpl.appId2ServiceName.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/app/appId2ServiceName`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
